import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Redux States
import {
  GET_CATEGORY_LIST_REQUEST,
  GET_CATEGORY_LIST_FOR_SUB_CATEGORY_REQUEST,
  GET_CATEGORY_LIST_FOR_PRODUCT_CATEGORY_REQUEST,
  GET_CHILD_CATEGORY_LIST_REQUEST,
  ADD_CATEGORY_REQUEST,
  UPDATE_CATEGORY_BY_CATEGORY_ID_REQUEST,
  UPDATE_CATEGORY_STATUS_BY_CATEGORY_ID_REQUEST,
  DELETE_CATEGORY_BY_CATEGORY_ID_REQUEST,
} from "./actionTypes";
import {
  updateCategoryStatusByCategoryIdResponse,
  getCategoryListForSubCategoryResponse,
  getCategoryListForProductCategoryResponse,
  getChildCategoryListResponse,
  getCategoryListResponse,
  addCategoryResponse,
  updateCategoryByCategoryIdResponse,
  deleteCategoryByCategoryIdResponse,
} from "./actions";
import { invokeApi } from "helpers/axiosHelper";
import { handleApiCallException } from "store/Shared/actions";
function* getCategoryList() {
  try {
    const response = yield call(
      invokeApi,
      "get",
      "/CategoryMaster/GetAllByCategoryType/1",
      ""
    );
    yield put(getCategoryListResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

function* getCategoryListForSubCategory() {
  try {
    const response = yield call(
      invokeApi,
      "get",
      "/CategoryMaster/GetCategoriesForSubCategory",
      ""
    );
    yield put(getCategoryListForSubCategoryResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

function* getCategoryListForProductCategory() {
  try {
    const response = yield call(
      invokeApi,
      "get",
      "/CategoryMaster/GetCategoriesForProductCategory",
      ""
    );
    yield put(getCategoryListForProductCategoryResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

function* getChildCategoryList() {
  try {
    const response = yield call(
      invokeApi,
      "get",
      "/CategoryMaster/GetAllByCategoryType/2",
      ""
    );
    yield put(getChildCategoryListResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

function* addCategory({ payload: { data } }) {
  try {
    const response = yield call(invokeApi, "post", "/CategoryMaster", data);
    // if (response.isSuccessResponse) {
    //     yield put(getCategoryListRequest());
    // }
    yield put(addCategoryResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

function* updateCategoryByCategoryId({ payload: { categoryId, data } }) {
  try {
    const response = yield call(
      invokeApi,
      "put",
      "/CategoryMaster/" + categoryId,
      data
    );
    yield put(updateCategoryByCategoryIdResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

function* deleteCategoryByCategoryId({ payload: { categoryId } }) {
  try {
    const response = yield call(
      invokeApi,
      "delete",
      "/CategoryMaster/" + categoryId
    );
    yield put(deleteCategoryByCategoryIdResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

function* updateCategoryStatusByCategoryId({
  payload: { categoryId, status },
}) {
  try {
    const response = yield call(
      invokeApi,
      "patch",
      "/CategoryMaster/" + categoryId + "/" + status
    );
    yield put(updateCategoryStatusByCategoryIdResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

export function* watchCategoryMaster() {
  yield takeEvery(GET_CATEGORY_LIST_REQUEST, getCategoryList);
  yield takeEvery(
    GET_CATEGORY_LIST_FOR_SUB_CATEGORY_REQUEST,
    getCategoryListForSubCategory
  );
  yield takeEvery(
    GET_CATEGORY_LIST_FOR_PRODUCT_CATEGORY_REQUEST,
    getCategoryListForProductCategory
  );
  yield takeEvery(GET_CHILD_CATEGORY_LIST_REQUEST, getChildCategoryList);
  yield takeEvery(ADD_CATEGORY_REQUEST, addCategory);
  yield takeEvery(
    UPDATE_CATEGORY_BY_CATEGORY_ID_REQUEST,
    updateCategoryByCategoryId
  );
  yield takeEvery(
    DELETE_CATEGORY_BY_CATEGORY_ID_REQUEST,
    deleteCategoryByCategoryId
  );
  yield takeEvery(
    UPDATE_CATEGORY_STATUS_BY_CATEGORY_ID_REQUEST,
    updateCategoryStatusByCategoryId
  );
}

function* categoryMasterSaga() {
  yield all([fork(watchCategoryMaster)]);
}

export default categoryMasterSaga;
